import { jsxs as d, jsx as e } from "react/jsx-runtime";
import { useState as u, useEffect as f } from "react";
import x from "react-image-crop";
import n from "./index10.js";
import { textStyles as $, token as r, Box as C, Flex as p, Badge as y } from "@bynder/design-system";
import { useCropProperties as l, useImageProperties as w, useAspectProperties as S, useImageCropperActions as P, useCropPixelProperties as b } from "./index15.js";
import { useScaledMinimumCropValues as _ } from "./index11.js";
import { getRatioBasedOnAspect as v } from "./index12.js";
import M from "./index44.js";
const V = () => {
  const t = l(), o = w(), { aspect: s } = S(), { setCrop: i } = P(), {
    ref: c,
    height: a,
    width: m,
    elementWidth: h
  } = _();
  return /* @__PURE__ */ d(C, { paddingTop: "3", children: [
    /* @__PURE__ */ e(M, {}),
    /* @__PURE__ */ d(
      p,
      {
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "3",
        children: [
          /* @__PURE__ */ e(p, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ e(
            k,
            {
              className: "ReactCrop--no-animate",
              crop: t,
              onChange: (A, g) => i(g),
              ruleOfThirds: !0,
              keepSelection: !0,
              minHeight: a,
              minWidth: m,
              aspect: v(s),
              circularCrop: s === "circle",
              $svgScaling: o.src.includes(".svg"),
              children: /* @__PURE__ */ e("img", { src: o.src, alt: "Cropper content", ref: c })
            }
          ) }),
          /* @__PURE__ */ e(R, { maxWidth: h })
        ]
      }
    )
  ] });
}, R = ({ maxWidth: t }) => {
  const [o, s] = u({
    left: "0%",
    right: "0%"
  }), i = l(), { width: c, height: a } = b();
  return f(() => {
    s({
      left: `${i.x}%`,
      right: `${100 - (i.x + i.width)}%`
    });
  }, [i]), /* @__PURE__ */ e(W, { $maxWidth: `${t.toFixed()}px`, children: /* @__PURE__ */ e(
    j,
    {
      $leftMargin: o.left,
      $rightMargin: o.right,
      children: /* @__PURE__ */ e(p, { justifyContent: "center", children: /* @__PURE__ */ e(D, { children: /* @__PURE__ */ e(F, { children: `${c.toFixed()} × ${a.toFixed()}` }) }) })
    }
  ) });
}, W = n.div.attrs((t) => ({
  style: {
    width: t.$maxWidth
  }
}))`
  display: flex;
  justify-content: center;
  align-items: center;
`, j = n.div.attrs((t) => ({
  style: {
    marginLeft: t.$leftMargin,
    marginRight: t.$rightMargin
  }
}))``, D = n(y)`
  min-width: 90px;
`, F = n.span`
  ${$.uiTextS}
  font-weight: 200;
  padding-top: ${r.spacing1};
  padding-bottom: ${r.spacing1};
`, k = n(x)`
  max-height: 506px;
  cursor: auto;

  // Add min-width in order to support svgs without width
  min-width: ${(t) => t.$svgScaling ? "512px" : "inherit"};
  .ReactCrop__child-wrapper > img {
    min-width: ${(t) => t.$svgScaling ? "100%" : "inherit"};
  }

  &.ReactCrop--no-animate {
    .ReactCrop {
      &__drag-handle {
        background-color: ${r.white};
        border: 2px solid ${r.brandPrimary500};
        border-radius: 10%;
      }

      &__crop-selection {
        border: 2px solid ${r.brandPrimary500};
        outline: none;
      }

      &__rule-of-thirds {
        &-hz,
        &-vt {
          &::before,
          &::after {
            background-color: ${r.white};
            opacity: 60%;
          }
        }
      }
    }
  }
`;
export {
  V as CropperSection
};
